import { defineComponent as _defineComponent } from 'vue'
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { AxiosError } from 'axios';
import { ref } from 'vue';

import validateState from '@/composables/validateState';
import api from '~api/api';
import ApiErrorMessage from '~widget/ApiErrorMessage';


export default /*#__PURE__*/_defineComponent({
  __name: 'VoucherUserIdentificationForm',
  props: {
  token: {
    type: String,
    required: false,
    default: '',
  },
},
  setup(__props) {

const props = __props

const errors = ref([]);



const loading = ref(false);

const form = ref({
  lastName: '',
  firstName: '',
  email: '',
});

const rules = {
  lastName: { required },
  firstName: { required },
  email: {
    required,
    email,
  },
};

const originalErrorCode = ref('');

const v$ = useVuelidate(rules, form);

const state = (v: string) => validateState(v, v$);

async function authVoucherUser() {
  await api
    .post('/vouchers/user-identification', form.value, {
      headers: {
        'x-jwt-token': `${props.token}`,
      },
    })
    .then((response) => {
      errors.value = [];
      originalErrorCode.value = response.data.originalErrorCode;
    })
    .catch((e: AxiosError) => {
      errors.value = e?.response?.data.errors;
    })

    .finally(() => {
      loading.value = false;
    });
}

function submitForm() {
  v$.value.$touch();

  if (!v$.value.$invalid) {
    authVoucherUser();
  }
}

return { __sfc: true,errors, props, loading, form, rules, originalErrorCode, v$, state, authVoucherUser, submitForm, email, required, ApiErrorMessage }
}

})